import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import BG from "../../assets/Frame 11.png";
import Logo from "../../assets/logo.png";

const Login = () => {
  const [email, setEmail] = useState("");
  const [motDePasse, setMotDePasse] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const utilisateur = await login(email, motDePasse);
      if (utilisateur.role === "Administrateur") navigate("/admin/dashboard");
      else if (utilisateur.role === "Superviseur") navigate("/superviseur/dashboard");
      else if (utilisateur.role === "Commercial") navigate("/commercial/dashboard");
    } catch (err) {
      setError(err.response?.data?.error || "Email ou mot de passe incorrect");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh", width: "100%" }}>

      {/* ── Image gauche (tablette et desktop) ── */}
      <div
        className="hidden md:block"
        style={{ flex: "0 0 50%", position: "relative", minHeight: "100vh", overflow: "hidden" }}
      >
        <img
          src={BG}
          alt=""
          style={{
            position: "absolute",
            top: 0, left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "top center",
            display: "block",
          }}
        />
      </div>

      {/* ── Formulaire droite ── */}
      <div style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "white",
        padding: "0 2rem 2rem 2rem",
        minHeight: "100vh",
        overflowY: "auto",
      }}>

        {/* Mobile : image en haut pleine largeur — collée tout en haut */}
        <div className="md:hidden" style={{ width: "calc(100% + 4rem)", marginLeft: "-2rem", marginTop: "-13rem", marginBottom: "1.5rem", alignSelf: "flex-start" }}>
          <img
            src={BG}
            alt=""
            style={{
              width: "100%",
              height: "240px",
              objectFit: "cover",
              objectPosition: "center top ",
              display: "block",
            }}
          />
        </div>

        {/* Logo */}
        <div style={{ marginBottom: "1.5rem", textAlign: "center" }}>
          <img
            src={Logo}
            alt="Banque Bleue"
            style={{ width: "90px", height: "90px", objectFit: "contain" }}
          />
        </div>

        {/* Titre */}
        <h2 style={{
          fontSize: "1.5rem", fontWeight: 700,
          color: "#1f2937", marginBottom: "1.5rem", textAlign: "center"
        }}>
          Bienvenue
        </h2>

        {/* Erreur */}
        {error && (
          <div style={{
            width: "100%", maxWidth: "380px", marginBottom: "1rem",
            padding: "0.75rem 1rem", backgroundColor: "#fef2f2",
            border: "1px solid #fecaca", borderRadius: "0.5rem",
            color: "#dc2626", fontSize: "0.875rem"
          }}>
            {error}
          </div>
        )}

        {/* Formulaire */}
        <form onSubmit={handleSubmit} style={{ width: "100%", maxWidth: "380px" }}>

          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            required
            style={{
              width: "100%", padding: "0.75rem 1rem",
              border: "1px solid #d1d5db", borderRadius: "0.5rem",
              fontSize: "1rem", color: "#374151", outline: "none",
              marginBottom: "1rem", boxSizing: "border-box", background: "white"
            }}
          />

          <div style={{ position: "relative", marginBottom: "0.5rem" }}>
            <input
              type={showPassword ? "text" : "password"}
              value={motDePasse}
              onChange={(e) => setMotDePasse(e.target.value)}
              placeholder="Mot de passe"
              required
              style={{
                width: "100%", padding: "0.75rem 3rem 0.75rem 1rem",
                border: "1px solid #d1d5db", borderRadius: "0.5rem",
                fontSize: "1rem", color: "#374151", outline: "none",
                boxSizing: "border-box", background: "white"
              }}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: "absolute", right: "1rem", top: "50%",
                transform: "translateY(-50%)", background: "none",
                border: "none", cursor: "pointer", color: "#9ca3af", padding: 0
              }}
            >
              {showPassword ? (
                <svg xmlns="http://www.w3.org/2000/svg" style={{ width: "1.25rem", height: "1.25rem" }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 4.411m0 0L21 21" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" style={{ width: "1.25rem", height: "1.25rem" }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
              )}
            </button>
          </div>

          <div style={{ textAlign: "right", marginBottom: "1.5rem" }}>
            <Link to="/mot-de-passe-oublie" style={{ fontSize: "0.875rem", color: "#6b7280", textDecoration: "none" }}>
              Mot de passe oublié ?
            </Link>
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%", padding: "0.85rem",
              background: "linear-gradient(135deg, #1d4ed8, #2563eb)",
              color: "white", fontWeight: 700, fontSize: "1rem",
              borderRadius: "9999px", border: "none",
              cursor: loading ? "not-allowed" : "pointer",
              display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem",
              boxShadow: "0 4px 14px rgba(37,99,235,0.4)",
              opacity: loading ? 0.7 : 1
            }}
          >
            {loading ? (
              <>
                <svg style={{ width: "1.25rem", height: "1.25rem", animation: "spin 1s linear infinite" }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                  <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
                </svg>
                Connexion...
              </>
            ) : "Connexion"}
          </button>

        </form>
      </div>
    </div>
  );
};

export default Login;